/**
 * 产业链可视化共享常量
 *
 * 这里集中所有跨组件使用的色板、标签字典。
 * - BOTTLENECK_COLORS / CHAIN_COLORS / TYPE_COLORS / TYPE_LABELS：与 nodes.json 字段一一对应
 * - QUADRANT_COLORS / QUADRANT_LABELS：与 rankings.json 中的 `quadrant` 字段一一对应（中文键）
 *
 * 注：ChainMap.tsx 当前还内联着一份英文键的 QUADRANT_COLORS/QUADRANT_LABELS，
 *     与数据实际值不匹配（永远命中 fallback 灰色）。这是一个已知的视觉小问题，
 *     M5 重写 SkillTreeMap 时会切到本文件的中文键版本。
 */

export const BOTTLENECK_COLORS: Record<string, string> = {
  high: '#ef4444',
  medium: '#f59e0b',
  low: '#94a3b8',
};

export const CHAIN_COLORS: Record<string, string> = {
  nvidia: '#10b981',
  google: '#3b82f6',
  huawei: '#a855f7',
};

export const CHAIN_LABELS: Record<string, string> = {
  nvidia: '英伟达链',
  google: '谷歌链',
  huawei: '华为链',
};

export const CHAIN_BADGES: Record<string, string> = {
  nvidia: 'N',
  google: 'G',
  huawei: 'H',
};

export const TYPE_LABELS: Record<string, string> = {
  chip: '芯片',
  material: '材料',
  component: '零部件',
  module: '模组',
  system: '系统',
  process: '工艺',
  equipment: '设备',
  chemical: '化学品',
  mineral: '矿产',
  service: '服务',
  foundry: '代工',
  substrate: '基板',
  gas: '气体',
};

export const TYPE_COLORS: Record<string, string> = {
  chip: '#3b82f6',
  material: '#10b981',
  component: '#f59e0b',
  module: '#8b5cf6',
  system: '#ef4444',
  process: '#06b6d4',
  equipment: '#f97316',
  chemical: '#ec4899',
  mineral: '#84cc16',
  service: '#6366f1',
  foundry: '#0ea5e9',
  substrate: '#a855f7',
  gas: '#14b8a6',
};

/**
 * 优先级象限色板。键值与 rankings.json 的 `quadrant` 字段对齐（中文）。
 * `{ bg, text }` 双值形态：bg 用于 chip 背景，text 用于其上文字。
 */
export const QUADRANT_COLORS: Record<string, { bg: string; text: string }> = {
  '核心主攻': { bg: '#dcfce7', text: '#166534' },
  '质量等待': { bg: '#dbeafe', text: '#1e40af' },
  '弹性交易': { bg: '#ffedd5', text: '#9a3412' },
  '低优先级': { bg: '#f3f4f6', text: '#6b7280' },
};

/**
 * 单色版象限色（供单一背景色场景使用，如圆点指示器）。
 */
export const QUADRANT_DOT_COLORS: Record<string, string> = {
  '核心主攻': '#10b981',
  '质量等待': '#3b82f6',
  '弹性交易': '#f59e0b',
  '低优先级': '#94a3b8',
};

/**
 * 象限标签是其本身（中文键已经是显示用），保留映射以便未来若需中英切换。
 */
export const QUADRANT_LABELS: Record<string, string> = {
  '核心主攻': '核心主攻',
  '质量等待': '质量等待',
  '弹性交易': '弹性交易',
  '低优先级': '低优先级',
};
